// extracted by mini-css-extract-plugin
export default {"wrap":"DogSexInput_wrap__izc91","h3":"DogSexInput_h3__qCNao","select":"DogSexInput_select__suc7H"};